export default "__VITE_ASSET__Db48AsOY__"